/**
 * ArrayBuffer から文字コードを自動判別してテキストへデコードする。
 *
 * 判別順序：
 * 1. UTF-8 BOM（EF BB BF）が付いている → UTF-8 としてデコード
 * 2. BOM なし → UTF-8（strict）でデコードを試み、不正バイト列があれば CP932 にフォールバック
 *
 * ASCII のみの Shift_JIS ファイルは UTF-8 strict で正常にデコードされるため
 * 結果は同じになる。
 */
export const decodeBuffer = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);

  // UTF-8 BOM チェック（EF BB BF）
  if (bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf) {
    return new TextDecoder('utf-8').decode(buffer);
  }

  // BOM なし: UTF-8 で strict デコードを試みる
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(buffer);
  } catch {
    // UTF-8 として不正なバイト列 → CP932 (Shift_JIS) にフォールバック
    return new TextDecoder('shift_jis').decode(buffer);
  }
};
